import { connect } from 'react-redux'
import { getDispatch, getState } from 'x/modules/payment/PaymentListViewConnect'
import PaymentListView from './PaymentListView'

export default connect(
  (state) => getState(state),
  (dispatch) => getDispatch(dispatch)
)(PaymentListView)
